import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser';

import { UserProvider } from '../../providers/user';
import { DataProvider } from '../../providers/data';

import { MessagePage } from '../message/message';

/**
 * Generated class for the PhonebookProfilePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-phonebook-profile',
  templateUrl: 'phonebook-profile.html',
})
export class PhonebookProfilePage {
title: string = '';
  name: string = '';
  surname: string = '';
  image: string = '';
  phoneNumber: any = '';
  phoneNumberHTML: any = '';
  phoneNumberUnprotected: any = '';
  mobileNumberUnprotected: any = '';
  mobileNumber: any = '';
  mobileNumberCall: any = '';
  mobileNumberHTML: any = '';
  mailAddress: string = '';
  company: string = '';
  company_details: any = [];
  company_phone: any;
  branche: string = '';
  position: string = '';
  chatKey: string = '';
  canStartChat: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public dataProvider: DataProvider, private sanitizer: DomSanitizer) {
    this.name = this.navParams.get('name');
    this.surname = this.navParams.get('surname');
    this.image = this.navParams.get('image');
    this.phoneNumber = this.sanitizer.bypassSecurityTrustResourceUrl('tel://' + this.navParams.get('phone'));
    this.phoneNumberUnprotected = this.navParams.get('phone');
    this.mobileNumber = this.sanitizer.bypassSecurityTrustResourceUrl('sms://' + this.navParams.get('mobile'));
    this.mobileNumberUnprotected = this.navParams.get('mobile');
    this.mobileNumberCall = this.sanitizer.bypassSecurityTrustResourceUrl('tel://' + this.navParams.get('mobile'));
    this.mobileNumberHTML = this.sanitizer.bypassSecurityTrustHtml(this.navParams.get('mobile'));
    this.phoneNumberHTML = this.sanitizer.bypassSecurityTrustHtml(this.navParams.get('phone'));
    this.mailAddress = this.navParams.get('mail');
    this.company = this.navParams.get('company');
    this.company_details = this.navParams.get('company_details');
    this.chatKey = this.navParams.get('chat_key');

    if(this.navParams.get('title')) {
        this.title = this.navParams.get('title');
    }

    if(this.company_details) {
        this.company_phone = this.sanitizer.bypassSecurityTrustResourceUrl('tel://' + this.company_details.phone);
    }
    this.branche = this.navParams.get('branche');
    this.position = this.navParams.get('position');
  }

  closeProfile() {
      this.navCtrl.pop();
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad PhonebookProfilePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/phonebook-profile/phonebook-profile.ts